import React, { Component, Fragment } from 'react';
import './Downloads.module.scss';

import PageTitle from '../../components/UI/PageTitle/PageTitle'
import Button from '../../components/UI/Button/Button'
import ButtonFullWidth from '../../components/UI/download-button/ButtonFullWidth/ButtonFullWidth';
import SideNavigation from 'components/UI/SideNavigation/SideNavigation';
import TopNavigation from 'components/UI/TopNavigation/TopNavigation';
import PageWrapper from 'components/UI/PageWrapper/PageWrapper';
import BackgroundPolygons from 'components/UI/BackgroundPolygons/BackgroundPolygons';

class DownloadsProcessing extends Component {

    //scroll to top
    componentDidUpdate() {
        window.scrollTo(0,0);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        return (
            <Fragment>
                <TopNavigation/>
                <SideNavigation/>
                <PageWrapper>
                    <div styleName='main'>
                    <BackgroundPolygons></BackgroundPolygons>
                        <div styleName='maxwidth'>
                            <PageTitle title='Downloads' subtitle='Processing'/>
                            <div styleName='downloadblock'>
                                <div styleName='polygon1'></div>
                                <div styleName='polygon2'></div>
                                <p>Kies de geschikte download voor jou computer.</p>
                                <div styleName='download-elements'>
                                    <div styleName='download-element'>
                                        <img src='/images/svg/windows32.svg'></img>
                                        <h3>Windows</h3>
                                        <ButtonFullWidth text='Windows' link='/storage/software-downloads/processing-windows.zip'/>
                                    </div>
                                    <div styleName='download-element'>
                                        <img src='/images/svg/macos.svg'></img>
                                        <h3>Mac OS</h3>
                                        <ButtonFullWidth text='Mac OS' link='/storage/software-downloads/processing-mac-os.zip'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </PageWrapper>
            </Fragment>
        );
    }
}

export default DownloadsProcessing;


// WEBPACK FOOTER //
// ./resources/assets/screens/DownloadsProcessing/DowloadsProcessing.jsx